import React from "react";
import { brl } from "../lib/format";

const QUICK_REASONS = [
  "Não pagou",
  "Bloqueou",
  "Desistiu",
  "Sem retorno",
  "Endereço errado",
  "Produto indisponível",
];

/**
 * Modal to capture a withdrawal (desistência/bloqueio) reason before firing the API.
 * Props:
 *  - data:    { handle, live_id?, total?, reason }
 *  - onChange(nextData)
 *  - onCancel()
 *  - onConfirm()
 *  - busy:    boolean
 */
export default function WithdrawReasonModal({ data, onChange, onCancel, onConfirm, busy }) {
  const { handle, live_id, total, reason } = data;
  const scope = live_id ? "esta live" : "TODAS as lives em aberto";
  const setReason = (r) => onChange({ ...data, reason: r });
  const isPicked = (label) => (reason || "").trim().toLowerCase() === label.toLowerCase();
  return (
    <div data-testid="withdraw-modal" className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="card-brutal bg-brand-cream w-full max-w-lg">
        <div className="p-4 border-b-2 border-brand-ink bg-brand-peach flex items-center justify-between">
          <div>
            <p className="label-brutal">Registrar desistência / bloqueio</p>
            <h3 className="font-heading text-xl font-black">{handle}</h3>
            <p className="text-xs">Escopo: <strong>{scope}</strong>{total ? <> · {brl(total)}</> : null}</p>
          </div>
          <button data-testid="withdraw-modal-close" onClick={onCancel} className="btn-white !h-9 !px-2">✕</button>
        </div>
        <div className="p-4 space-y-3">
          <div>
            <label className="label-brutal">Motivos rápidos</label>
            <div className="flex flex-wrap gap-2">
              {QUICK_REASONS.map(r => (
                <button
                  key={r}
                  type="button"
                  data-testid={`withdraw-quick-${r.toLowerCase().replace(/\s+/g, "-").normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`}
                  onClick={() => setReason(r)}
                  className={`btn-brutal !h-9 !px-3 text-xs ${isPicked(r) ? "bg-brand-pink text-white" : "bg-white hover:bg-brand-yellow"}`}
                >
                  {r}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="label-brutal">Motivo (personalizado — opcional)</label>
            <textarea
              data-testid="withdraw-reason-input"
              className="input-brutal !h-24 resize-none"
              maxLength={200}
              placeholder="Ex: bloqueou no direct, endereço não confirmado…"
              value={reason || ""}
              onChange={(e) => setReason(e.target.value)}
              autoFocus
            />
            <p className="text-[10px] text-brand-ink2 text-right mt-1">{(reason || "").length}/200</p>
          </div>
        </div>
        <div className="p-4 border-t-2 border-brand-ink flex flex-wrap justify-end gap-2">
          <button data-testid="withdraw-cancel-btn" onClick={onCancel} className="btn-white h-11">Cancelar</button>
          <button
            data-testid="withdraw-confirm-btn"
            onClick={onConfirm}
            disabled={busy}
            className="btn-brutal bg-brand-peach text-brand-ink hover:bg-brand-pink hover:text-white h-11 disabled:opacity-40"
          >
            Confirmar desistência
          </button>
        </div>
      </div>
    </div>
  );
}
